import React from 'react';
import classes from './style.module.scss';
import { WorkOrderTaskMaterialList } from '~/workorder/types';
import useTranslation from '~/app/hooks/useTranslation';
import Icon from '~/app/common/Icon';

export interface MaterialsProps {
    materials: WorkOrderTaskMaterialList[];
}

export type MaterialsComponent = React.FC<MaterialsProps>;

const Materials: MaterialsComponent = ({ materials }) => {
    const { t } = useTranslation('workorder');
    const { t: tParts } = useTranslation('parts');

    return (
        <div className={classes.card}>
        <div className={classes['section-header']}>
            <h2 className={classes['section-header-title']}>
                <Icon name="build" size={20} className={classes['section-header-icon']} />
                {tParts('material')}
            </h2>
        </div>
        {materials.length === 0 ? (
            <p className={classes.empty}>{t('detail.noMaterials')}</p>
        ) : (
            <div className={classes.list}>
                {materials.map(material => (
                    <div key={material.id} className={classes['list-row']}>
                        <div className={classes['row-main']}>
                            <p className={classes['row-name']}>{material.id ? material.name : tParts('variousMaterial')}</p>
                        </div>
                        <div className={classes['row-actions']}>
                            <span className={classes['row-quantity']}>
                                {material.quantity} {tParts('item')}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        )}
    </div>
    );
};

export default Materials;
